import clsx from 'clsx';
import { ReactNode, startTransition } from 'react';
import { GridComponents, VirtuosoGrid } from 'react-virtuoso';
import { StreamCardFragmentFragment } from '@/__generated__/graphql.ts';
import { useRestoreGridFeed } from '@/components/feed/restore-feed/use-restore-grid-feed.ts';
import { StreamCard } from '@/components/stream-list/stream-card/stream-card.tsx';
import { streamsGrid } from '@/components/stream-list/stream-list.css.ts';

const StreamGridComponents: GridComponents = {
  List: function List({ ref, className, ...props }) {
    return (
      <div ref={ref} className={clsx(streamsGrid, className)} {...props} />
    );
  },
};

export const StreamList = ({
  streams,
  loadMore,
  hasNext,
  emptyState,
  skeletonItemCount,
}: {
  streams: StreamCardFragmentFragment[];
  hasNext: boolean;
  loadMore: () => void;
  emptyState: ReactNode;
  skeletonItemCount?: number;
}) => {
  const onEndReached = () => {
    if (hasNext) {
      startTransition(() => {
        loadMore();
      });
    }
  };

  const { restoreStateFrom, style, setFeedPosition } = useRestoreGridFeed();

  return streams.length > 0 ? (
    <VirtuosoGrid
      stateChanged={setFeedPosition}
      restoreStateFrom={restoreStateFrom}
      style={style}
      data={streams}
      initialItemCount={Math.min(skeletonItemCount || 0, streams.length)}
      itemContent={(_idx: number, stream: StreamCardFragmentFragment) => (
        <StreamCard stream={stream} />
      )}
      endReached={onEndReached}
      components={StreamGridComponents}
      increaseViewportBy={800}
      useWindowScroll
    />
  ) : (
    emptyState
  );
};
